import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-22db8925"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "task-estimate-page" }

import { TaskDetail } from "@/components";

/**Параметры */

export default /*#__PURE__*/_defineComponent({
  __name: 'task-estimate-page',
  props: {
  /**ID задачи */
  taskId: { type: Number },
  /**ID очереди */
  queueId: { type: String },
  /**ID проекта */
  projectId: { type: Number },
  /**ID неймспейса */
  namespaceId: { type: String },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(TaskDetail), {
      projectId: __props.projectId,
      namespaceId: __props.namespaceId,
      queueId: __props.queueId,
      "task-id": __props.taskId,
      "is-estimate": ""
    }, null, 8, ["projectId", "namespaceId", "queueId", "task-id"])
  ]))
}
}

})